const types = {
    SAVE_PARAMS: 'PERSONAL/SAVE_PARAMS',
    SAVE_QUERY_PARAMS: 'PERSONAL/SAVE_QUERY_PARAMS',
};

export const saveParams = params => ({
    type: types.SAVE_PARAMS,
    params,
});

export const saveQueryParams = params => ({
    type: types.SAVE_QUERY_PARAMS,
    params,
});

const initState = {
    params: {
        isChinese: true,
    },
    queryParams: {},
};

const reducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_PARAMS:
            return {
                ...state,
                params: {
                    ...state.params,
                    ...actions.params,
                },
            };
        case types.SAVE_QUERY_PARAMS:
            return {
                ...state,
                queryParams: {
                    ...actions.params,
                },
            };
        default:
            return state;
    }
}

export default reducer;


// WEBPACK FOOTER //
// ./src/actions/PersonalActions.js